<template>
    <div>
        <div class="message">{{ lang($t("Opps! The page you're going to visit doesn't exist.")) }}</div><br>
        <div style="text-align: center;"><a href="home" class="action-btn h32"><p>{{ lang($t("Go To Homepage")) }}</p></a></div>
    </div>
</template>

<script>

    import api from '@js/api';
    import {common} from "@mixins/common";
    import EventBus from '@common/eventBus';
    import Vue from 'vue';
    import axios from 'axios';

    export default {
        name: "NotFound",
        mixins:[common],
        beforeRouteEnter (to, from, next) {
            next(vm=>{
                EventBus.$emit("showGlobalLoading");

                //TODO: check if logged in, if not logged in, don't get download data
                Promise.all(
                    [
                        api.getMainCate()
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate) => {
                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }

                        EventBus.$emit("hideGlobalLoading");

                    }))
                /*.catch(error=>{
                    //Handle errors here if something is expected to precess here
                });
                */
            })

        },
    }

</script>

<style scoped>
    .message {
        text-align:center;
        margin:200px 0 0 0;
        font-size:16px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/NotFound.vue